import React from "react";
import PropTypes from "prop-types";
import BloombergBanner from "components/v3/bloomberg-banner/BloombergBanner";
import getEnvironmentName from "utils/getEnvironmentName";
import styles from "./styles.module.scss";

const Layout = ({ bloombergSiteUrl, location: { pathname }, children }) => {
    const environment = getEnvironmentName();
    const environmentStyle = styles[environment] || "";

    return (
        <div className={ `${ styles.layout } ${ environmentStyle }` }>
            <div className={ styles.banner }>
                <BloombergBanner bloombergSiteUrl={ bloombergSiteUrl } pathname={ pathname } />
            </div>
            { children }
        </div>
    );
};

Layout.propTypes = {
    bloombergSiteUrl: PropTypes.string.isRequired
};

export default Layout;
